import { render, staticRenderFns } from "./ContentTypeUsersBtn.vue?vue&type=template&id=5525cbf4&"
import script from "./ContentTypeUsersBtn.vue?vue&type=script&lang=ts&"
export * from "./ContentTypeUsersBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports